import { createContext, ReactNode, useContext, useMemo } from 'react';

// null = no provider (fall back to URL params)
// { submissionId: undefined } = provider exists, still loading
// { submissionId: string } = provider has the correct ID
const SubmissionIdContext = createContext<{ submissionId?: string } | null>(null);

interface SubmissionIdProviderProps {
  submissionId?: string;
  children: ReactNode;
}

export function SubmissionIdProvider({ submissionId, children }: SubmissionIdProviderProps) {
  const value = useMemo(() => ({ submissionId }), [submissionId]);
  return <SubmissionIdContext.Provider value={value}>{children}</SubmissionIdContext.Provider>;
}

// Returns null if no provider exists, or the context value if it does
export function useSubmissionIdFromContext() {
  return useContext(SubmissionIdContext);
}
